import client from './client';

// 세금계산서 발행/수금 취소 + 수주품의서 단위 일괄 취소. bito 신설(2026-10-21).
// 수주품의서 관리(관리부 모니터링)와 재작성 가드 다이얼로그가 같은 review 데이터를 쓴다.
const baseUrl = '/api/v1/project/orders/bill-cancel';

// 수주품의서 1건의 매출/매입 세금계산서 전체 현황 - 상태/잠금사유/합계/권한.
export const getOrderBillReview = (roUuid) => client.get(`${baseUrl}/${roUuid}/review`);

// 발행 취소. 수금/지급이 이미 끝난 건은 서버가 거부한다(먼저 수금 취소 필요).
export const cancelIssueComplete = (invUuid) =>
  client.put(`${baseUrl}/${invUuid}/cancel-issue-complete`);

// 발행요청 취소.
export const cancelIssueRequest = (invUuid) =>
  client.put(`${baseUrl}/${invUuid}/cancel-issue-request`);

// 수금/지급 취소. 이 회차에 걸린 유효한 수금 내역을 전부(N건) 취소한다.
// 내역 하나만 콕 집어 취소하려면 billCollect.cancelCollectRecord를 쓴다.
export const cancelCollection = (invUuid, reason) =>
  client.put(`${baseUrl}/${invUuid}/cancel-collection`, { reason });

// 권한자 일괄 취소. 이 수주품의서의 모든 회차(수금→발행→발행요청)를 한 번에 되돌린다.
export const bulkCancelOrder = (roUuid, reason) =>
  client.post(`${baseUrl}/${roUuid}/bulk-cancel`, { reason });
